import { PERMISSIONS } from "../../constants";

// Quién puede entrar a cada rama de Extensión. Vive aquí, y no repartido por los
// tres hubs, porque el nivel de arriba y el de abajo tienen que responder lo
// MISMO: si el mosaico de "Convenios" se muestra pero su sub-hub no deja pasar,
// el usuario cae en una pantalla vacía; y si el de arriba redirige a una rama
// que abajo está vacía, se queda en el limbo.
//
// ADMIN entra por ROL, no por permiso: los permisos son una foto que se toma al
// crear la cuenta, así que agreement.* y entity.* no existen en las cuentas
// anteriores a esos módulos. Es el mismo criterio que aplican handleAgreement y
// handleEntity en el servidor.
export const isExtensionAdmin = (user) => (user?.roles || []).includes("ADMIN");

// La rama de Aspirantes: el banco de hojas de vida y su configuración.
export const canSeeApplicants = (user) => {
  const perms = user?.permissions || [];
  return (
    isExtensionAdmin(user) ||
    perms.includes(PERMISSIONS.APPLICANT.LIST) ||
    perms.includes(PERMISSIONS.APPLICANT.VALIDATE_DOC) ||
    perms.includes(PERMISSIONS.APPLICANT.SELECT)
  );
};

// La rama de Convenios: los convenios, las entidades con las que se firman y la
// configuración de ambos.
export const canSeeAgreements = (user) => {
  const perms = user?.permissions || [];
  return (
    isExtensionAdmin(user) ||
    perms.includes(PERMISSIONS.AGREEMENT.LIST) ||
    perms.includes(PERMISSIONS.ENTITY.LIST)
  );
};

// Con acceso a las dos ramas tiene sentido volver al nivel de arriba; con una
// sola, ese nivel devolvería al usuario justo a donde estaba.
export const hasBothBranches = (user) => canSeeApplicants(user) && canSeeAgreements(user);
